import ProtectImg from "./common/protect_img.es6";
import OsUtils from "./common/utils/os.es6";

import FollowBtn from "./common/ui/followBtn.es6";

// import SubMv from './top/sub_mv.es6';
import MainMv from "./top/main_mv.es6";
import Parallax from "./top/parallax.es6";
import Slider from "./top/slider.es6";
import GoodsSlider from "./top/goods_slider.es6";
import Scroll from "./top/scroll.es6";
import Modal from "./top/modal.es6";
import Acc from "./top/acc.es6";
import Tab from "./top/tab.es6";
import FixedBadge from "./top/fixed_badge.es6";

class Main {
    constructor() {
        this.protectImg = new ProtectImg();
        this.followBtn = new FollowBtn();
    
        this.mainMv = new MainMv(this);
        this.parallax = new Parallax();
        this.slider = new Slider();
        this.goodsSlider = new GoodsSlider();
        this.scroll = new Scroll();
        this.modal = new Modal();
        this.acc = new Acc();
        this.tab = new Tab(this);
    
        this.fixedBadge = new FixedBadge();
    
        this._setMobileClass();
        this._setHashScroll();
        this._init();
    }

    _setMobileClass() {
        OsUtils.getMobileOS && document.body.classList.add("-mobile");
    }

    _setHashScroll() {
        if ("scrollRestoration" in history) {
            history.scrollRestoration = "manual";
        }

        window.addEventListener("load", () => {
            if (window.location.hash !== "#streaming") return;

            const target = document.querySelector("#streaming");

            if (!target) return;

            setTimeout(() => {
                target.scrollIntoView({
                    behavior: "auto",
                    block: "start",
                });
            }, 500);
        });
    }

    _init() {
        document.body.classList.add("-ready");

        window.addEventListener("load", () => {
            // this.subMv.setAnimate();
            // this.mainMv.setAnimate();
            this.parallax.updateParallax();
            this.acc.setHeight();
            this.acc.eventBind();
        });

        document.addEventListener("DOMContentLoaded", () => {
            this.mainMv.setAnimate();
        });

        // リサイズ時、言語変更時、翻訳完了時にアコーディオンの高さを初期化
        const initHeight = () => this.acc.initHeight();
        window.addEventListener("resize", initHeight);
        window.addEventListener("wovnLangChanged", initHeight);
        window.addEventListener("wovnTranslationComplete", initHeight);
    }
}

const main = new Main();
